import React, { useCallback } from 'react';
import { formatStorePrice } from '../../../utils/ecommerce/currency.js';
import { isVatActive, isVatUndefined } from '../../../utils/ecommerce/vat.js';
import { VAT_BUSS_PRICE, VAT_CONS_PRICE, VAT_EXCLUDED, VAT_INCLUDED, VAT_SHOWING, VAT_VIEW } from '../data/Localization';

/**
 * Renders the product price component.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {number} props.activePrice - The active price of the product.
 * @param {string} props.renewalTitle - The renewal title of the product.
 * @param {string} props.formattedLocale - The formatted locale for currency display.
 * @param {string} props.currency - The currency code for price formatting.
 * @returns {JSX.Element} The rendered product price component.
 */
const ProductPrice = (props) => {
	// vat message state
	const [vatMessage, setVatMessage] = React.useState('');
	const [activeDispPrice, setActiveDispPrice] = React.useState(null);

	const formatPrice = useCallback((price) => {
		const isWholeNumber = price % 1 === 0;
		const currencyOptions = isWholeNumber ? { maximumFractionDigits: 0 } : undefined;
		return formatStorePrice(price, props.formattedLocale, props.currency, currencyOptions);
	}, [props.formattedLocale, props.currency]);

	React.useEffect(() => {
		// VAT :: check if all labels where authored
		const hasAllVATLabels = VAT_BUSS_PRICE && VAT_CONS_PRICE && VAT_EXCLUDED && VAT_INCLUDED && VAT_SHOWING && VAT_VIEW;
		const vatPriceSelection = !isVatUndefined();

		if (vatPriceSelection && hasAllVATLabels) {
			// set VAT message
			const isVatActiveVal = isVatActive();
			setVatMessage(isVatActiveVal ? VAT_INCLUDED : VAT_EXCLUDED);
		}
	}, []);

	React.useEffect(() => {
		let newDispPrice = typeof props.activePrice === 'number' && !isNaN(props.activePrice) ? formatPrice(props.activePrice) : null;
		newDispPrice = props.renewalTitle ? `${newDispPrice}${props.renewalTitle}` : newDispPrice;
		setActiveDispPrice(newDispPrice);
	}, [props.activePrice, props.renewalTitle, formatPrice]);

	return (
		<div className="prc__calc-total">
			<div className="calc-total__value">{activeDispPrice}</div>
			{vatMessage && <div className="calc-total__vat-text">{vatMessage}</div>}
		</div>
	);
};

export default ProductPrice;
